import { EstadoService } from 'src/app/servicos/estado.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutenticacaoService implements CanActivate{

  constructor(private est:EstadoService,  public router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    
    let path = route.routeConfig.path;
    if(path=='contato-diviprev')return true;
    if(!localStorage.getItem('cpf_logado')){      
      this.est.logOut();
      this.router.navigate(["/login"]);
      return false;
    }

    if(path=='autenticador'){
      let memo = this.est.load();
      if(memo && memo['whatsapp'] && memo['cpf']){ // caso já tenha autenticado o número a tela de validação não abre mais.
        this.router.navigate(['/inicial']);
      }

    }
    
    // if(!this.est.usuarioEstaAutenticado()){
    //   
    //   this.est.logOut();
    //   this.router.navigate(["/login"]);
    //   return false;
    // }
    return true;
  }
}
